import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';

const LoanDepositDashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { grampanchayatName, arthikVarshLabel } = location.state || {};

  // Using SVG icons as placeholders for Puzzle pieces described by user
  // Or using standard icons if puzzle piece is not available in standard react-icons
  // User said "puzzle piece" icon in the image description text, so I will try to use something similar or generic.
  // react-icons/fi doesn't have a puzzle piece. explicit puzzle icon might need fa or others.
  // I'll use a generic icon and label it clearly.
  
  const menuItems = [
    {
      id: 'karj',
      title: 'कर्ज',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-puzzle">
          <path d="M19.439 15.424a1 1 0 0 0-1.009.915c-.068.745-.636 1.334-1.381 1.432-1.295.17-2.315-1.127-1.745-2.227.182-.35.132-.779-.13-1.09l-1-1.179a1 1 0 0 0-1.157-.253c-.76.326-1.637.037-2.074-.683-.438-.722-.266-1.666.402-2.16.27-.2.378-.553.272-.876l-.508-1.543a1 1 0 0 0-1.144-.662c-.782.128-1.547-.506-1.547-1.282V4.5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h5.5a1 1 0 0 0 1-1v-2.066c0-.776.765-1.41 1.547-1.282.324.053.659-.092.836-.36l.508-1.543a1 1 0 0 1 1.144-.662c.78-.128 1.547.506 1.547 1.282V14.5a1 1 0 0 0 1 1h2.066c.776 0 1.41-.765 1.282-1.547-.053-.324.092-.659.36-.836l1.543-.508a1 1 0 0 1 .662 1.144c-.326.76-.037 1.637.683 2.074.72.438 1.66.266 2.16-.402l1.179-1a1 1 0 0 0 .253-1.157z"></path>
        </svg>
      ),
      description: 'कर्ज व्यवहार',
      path: '/panipuravtha/transactions/loan',
      color: 'from-blue-500 to-cyan-500'
    },
    {
      id: 'anamat',
      title: 'अनामत',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-puzzle">
          <path d="M19.439 15.424a1 1 0 0 0-1.009.915c-.068.745-.636 1.334-1.381 1.432-1.295.17-2.315-1.127-1.745-2.227.182-.35.132-.779-.13-1.09l-1-1.179a1 1 0 0 0-1.157-.253c-.76.326-1.637.037-2.074-.683-.438-.722-.266-1.666.402-2.16.27-.2.378-.553.272-.876l-.508-1.543a1 1 0 0 0-1.144-.662c-.782.128-1.547-.506-1.547-1.282V4.5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h5.5a1 1 0 0 0 1-1v-2.066c0-.776.765-1.41 1.547-1.282.324.053.659-.092.836-.36l.508-1.543a1 1 0 0 1 1.144-.662c.78-.128 1.547.506 1.547 1.282V14.5a1 1 0 0 0 1 1h2.066c.776 0 1.41-.765 1.282-1.547-.053-.324.092-.659.36-.836l1.543-.508a1 1 0 0 1 .662 1.144c-.326.76-.037 1.637.683 2.074.72.438 1.66.266 2.16-.402l1.179-1a1 1 0 0 0 .253-1.157z"></path>
        </svg>
      ),
      description: 'अनामत व्यवहार',
      path: '/panipuravtha/transactions/deposit',
      color: 'from-orange-500 to-amber-500' // Different color to distinguish
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 p-6 md:p-8 font-poppins">
      {/* Header */}
      <div className="max-w-7xl mx-auto mb-10">
        <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 flex flex-col md:flex-row justify-between items-center bg-gradient-to-r from-slate-800 to-slate-900 text-white">
          <div className="flex items-center gap-4">
             <button 
                onClick={() => navigate(-1)} 
                className="hover:bg-white/10 p-2 rounded-full transition-colors flex items-center justify-center"
            >
                <FiArrowLeft className="text-2xl" />
            </button>
            <div>
                <h1 className="text-3xl font-bold mb-2">कर्ज व अनामत</h1>
                <p className="text-slate-300">
                {grampanchayatName ? `${grampanchayatName} | ` : ''}आर्थिक वर्ष: {arthikVarshLabel || '२०२४-२५'}
                </p>
            </div>
          </div>
        </div>
      </div>

      {/* Menu Grid */}
      <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
        {menuItems.map((item) => (
          <div 
            key={item.id}
            onClick={() => item.path !== '#' && navigate(item.path, { state: location.state })}
            className="group cursor-pointer bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 overflow-hidden border border-gray-100"
          >
            <div className={`h-2 bg-gradient-to-r ${item.color}`}></div>
            <div className="p-8 text-center flex flex-col items-center">
              <div className={`w-20 h-20 rounded-xl bg-gradient-to-br ${item.color} flex items-center justify-center text-white mb-6 shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                {item.icon}
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-2 group-hover:text-blue-600 transition-colors">
                {item.title}
              </h3>
              <p className="text-gray-500">
                {item.description}
              </p>
            </div>
            <div className="px-6 py-4 bg-gray-50 border-t border-gray-100 flex justify-between items-center">
              <span className="text-sm font-medium text-gray-600 group-hover:text-blue-600 transition-colors">
                निवडा
              </span>
              <svg 
                className="w-5 h-5 text-gray-400 group-hover:text-blue-600 transform group-hover:translate-x-1 transition-all duration-300" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LoanDepositDashboard;
